import React from "react";
import styled from "styled-components";

const AboutSection = styled.section`
  width: 100%;
  background-color: #282828; /* Darker aesthetic background */
  color:rgb(252, 250, 250); /* White text */
  padding: 4rem 8rem;
  display: flex;
  justify-content: center;

  .container {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    max-width: 1200px;
    width: 100%;
    gap: 2rem;

   .text-content {
  flex: 3;

  h1 {
    font-size: 3rem;
    font-weight: normal;
    margin-bottom: 0.5rem; /* Reduced bottom margin */
    color:rgb(252, 250, 250); /* Golden color for the title */
  }

  h2 {
    font-size: 1.7rem;
    color:rgb(252, 250, 250); /* Light blue for subtitle */
    margin-bottom: 0.5rem; /* Reduced bottom margin for closer spacing */
  }

  p {
    font-size: 1.4rem;
    line-height: 1.8;
    color:rgb(252, 250, 250); /* Soft gray for readability */
    margin-top: 0; /* Ensure no top margin adds space */
  }

  span {
    font-size: 1.2rem;
    font-weight: bold;
    color:rgb(252, 250, 250); /* Vibrant green for emphasis */
  }
}

    .image-container {
      flex: 2;
      display: flex;
      justify-content: center;

      img {
        width: 100%;
        max-width: 450px;
        height: auto;
        border-radius: 12px;
        box-shadow: 0 6px 12px rgba(0, 0, 0, 0.4);
        border: 2px solid #1B1B1B; /* Border to match the title color */
      }
    }
  }

  @media (max-width: 768px) {
    padding: 2rem 1rem;
    
    .container {
      flex-direction: column;
      text-align: center;

      .text-content {
        h1 {
          font-size: 2.5rem;
          margin-bottom: 1rem;
        }

        h2 {
          font-size: 1.4rem;
          margin-bottom: 1rem;
          line-height: 1.4;
        }

        p {
          font-size: 1.1rem;
          line-height: 1.6;
          text-align: left;
          padding: 0;
          margin: 0;
        }

        span {
          font-size: 1.1rem;
          color: #23d997;
        }
      }

      .image-container {
        margin-top: 2rem;
      }
    }
  }

  /* Mobile devices iPhone, Pixel */
  @media only screen and (min-width: 320px) and (max-width: 539px) {
    padding: 1.5rem 1rem;
    
    .container {
      .text-content {
        h1 {
          font-size: 2rem;
          margin-bottom: 0.8rem;
        }

        h2 {
          font-size: 1.2rem;
          margin-bottom: 0.8rem;
          line-height: 1.3;
        }

        p {
          font-size: 1rem;
          line-height: 1.5;
          text-align: left;
          padding: 0;
          margin: 0;
        }

        span {
          font-size: 1rem;
          color: #23d997;
        }
      }
    }
  }
`;

const AboutUsSection = () => {
  return (
    <AboutSection id="about-us">
      <div className="container">
        <div className="text-content">
          <h1>About Us</h1>
          <h2>Innovating with Web Development, App Development, and AI Technologies</h2>
          <p>
            At <span>Callisto Solutions</span>, we are driven by a passion for creating cutting-edge
            technology solutions. Our expertise lies in crafting state-of-the-art web and mobile
            applications, leveraging the power of AI to deliver transformative results for businesses
            worldwide.
            We specialize in designing scalable, secure, and user-friendly solutions that redefine
            the digital experience. With a commitment to innovation and quality, we aim to
            empower businesses to thrive in a fast-evolving technological landscape.
          </p>
        </div>
        {/* <div className="image-container">
          <img
            src="https://areya.tech/wp-content/uploads/2022/12/image-1-compressed-scaled.jpg" // Replace with your actual image
            alt="Callisto Solutions"
          />
        </div> */}
      </div>
    </AboutSection>
  );
};

export default AboutUsSection;
